import React from "react";
import {
  AddSeasonForm,
  CreateGroupsForm,
  CreateMatchesForm,
  DeleteSeasonForm,
  RegenerateTableForm,
} from "./components/AdminForms";

const ManageSeason: React.FC = () => {
  return (
    <div className="mx-auto flex flex-col justify-start items-center py-6 px-3 gap-y-6 w-full h-full overflow-y-auto mt-16">
      <>
        <AddSeasonForm />
        <CreateGroupsForm />
        <CreateMatchesForm />
        <DeleteSeasonForm />
        <RegenerateTableForm />
      </>
    </div>
  );
};
export default ManageSeason;
